import {
  Alert,
  AlertTitle,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { PrimaryButton } from "@/components/common/PrimaryButton";
import { useEffect } from "react";
import { SecondaryButton } from "@/components/common/SecondaryButton";

interface InvalidDocumentWarningProps {
  isOpen: boolean;
  onClose: () => void;
  isProfessional: boolean;
  fileBase64?: string;
}

export function InvalidDocumentWarning({
  isOpen,
  onClose,
  isProfessional,
  fileBase64,
}: InvalidDocumentWarningProps) {

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown={!isProfessional}
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
        <Typography variant="h6" component="span">
          Documento inválido
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          <AlertTitle>Atenção!</AlertTitle>
          Este arquivo pdf parece não ser um resultado de exame.
        </Alert>

        <Typography variant="body1" gutterBottom>
          Possíveis instruções:
        </Typography>

        <Box sx={{ pl: 2, mb: 2 }}>
          <Typography variant="body2" paragraph>
            • Evite utilizar fotos do resultado de exames
          </Typography>
          <Typography variant="body2" paragraph>
            • Entre em contato diretamente com a clínica ou profissional que realizou o atendimento
          </Typography>
          <Typography variant="body2" paragraph>
            • Verifique se o documento está no formato correto (PDF) e tente novamente
          </Typography>
          <Typography variant="body2" paragraph>
            • Certifique-se de que o documento contém informações de resultado de exames legíveis
          </Typography>
        </Box>

        {isProfessional && fileBase64 && (
          <Alert severity="info">
            <AlertTitle>Acesso profissional</AlertTitle>
            Como você está na visão de profissional, pode visualizar e processar o documento mesmo que não tenha sido identificado como um resultado de exame válido.
          </Alert>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 4 }}>

        <Stack direction="row" justifyContent="space-between" width="100%">
          <SecondaryButton
            width="fit-content"
            height="50px"
            onClick={() => onClose()}
            id="goBackButton"
          >
            Fechar
          </SecondaryButton>

          <PrimaryButton width="fit-content" height="50px" onClick={onClose}>
            Abrir Chat Luxor
          </PrimaryButton>
        </Stack>
      </DialogActions>
    </Dialog>
  );
} 